import React, { useState } from "react";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { t } from "i18next";
import OutsideClickHandler from "react-outside-click-handler";
import jwt_decode from "jwt-decode";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { pick } from "lodash";import { toast } from "react-toastify";
const Login = () => {

  const navigate = useNavigate();  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(true);
  const handleShow = () => {
    setShowPassword(!showPassword);
  };  const setUser = useContextSelector(AuthContext, (ctx) => ctx.setUser);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    unregister,
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
      uniqueId: Math.random() * 10000,
    },
  });

  let loginUser = async (body) => {
    setLoading(true);

    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    body.website = hostname || "SABAEXCH";
    const { status, data } = await apiPost(
      apiPath.loginUser,
      pick(body, ["username", "password", "uniqueId", "website"]),
    );
    if (data.success) {
        localStorage.setItem("chatId", data.results.platformType);
        localStorage.setItem("token", data.results.token);
        localStorage.setItem("refresh_token", data.results.refresh_token);
        setUser(jwt_decode(data.results.token));
      // if (data?.results?.isPasswordReset) {
      //   navigate("/reset-password");
      // } else {
        navigate("/");
      // }
    } else {
      toast.error(data?.message);
    }
    setLoading(false);
  };
  return (
    <div className="popup-page popup-page--active popup-page--align-top">
      <div className="popup-page__backdrop" />
      <OutsideClickHandler onOutsideClick={() => navigate(-1)}>
        <div className="popup-page__main popup-page-main popup-page-main--show">
          <div className="popup-page-main__header">
            <div className="popup-page-main__title">{t("Login")}</div>
            <div
              onClick={() => navigate("/")}
              className="popup-page-main__close ng-star-inserted"
            />
          </div>
          <div className="popup-page-main__container">
            <div className="content login-biometric-content">
              <div
                _ngcontent-serverapp-c381631582
                className="logo-box"
                style={{
                  "background-image": 'url("/assets/Other/logo.png")',
                }}
              />
              <Form
                onSubmit={handleSubmit(loginUser)}
                className="ng-untouched ng-pristine ng-invalid ng-star-inserted"
              >
                <div  className="menu-box">
                  <div className="input-group-wrapper">
                    <div className="input-group">
                      <label htmlFor="userId">{t("Username")}</label>
                      <input
                        removewhitespace
                        type="text"
                        className="input ng-untouched ng-pristine ng-invalid"
                        name="userId"
                        placeholder={t("Username")}
                        {...register("username", {
                          required: t("Enter_Valid_Username"),

                          validate: {
                            noLeadingSpaces: (value) =>
                              !/^\s/.test(value) || t("Enter_Valid_Username"),

                            noTrailingSpaces: (value) =>
                              !/\s$/.test(value) || t("Enter_Valid_Username"),

                            alphanumericOnly: (value) =>
                              /^[a-zA-Z0-9 ]*$/.test(value) ||
                              t("Only_Alphabets_And_Numbers_Allowed"),

                            noOnlySpaces: (value) =>
                              value.trim().length > 0 ||
                              t("Enter_Valid_Username"),

                            mustContainAlphabet: (value) =>
                              /[a-zA-Z]/.test(value) ||
                              t("Username_Must_Contain_At_Least_One_Letter"),

                            minLength: (value) =>
                              value.trim().length >= 3 || t("Min3User"),

                            maxLength: (value) =>
                              value.trim().length <= 30 || t("Max30User"),
                          },
                        })}
                      />
                      <input type="button" className="clear" />
                    </div>
                    {errors.username && errors.username.message && (
                      <div className="alert">{errors.username.message}</div>
                    )}
                  </div>
                  <div className="input-group-wrapper">
                    <div className="input-group password">
                      <div
                        onClick={() => handleShow()}
                        _ngcontent-serverapp-c2292208966
                        className={`eyes ${!showPassword ? "active" : ""} `}
                      />
                      <label htmlFor="password">{t("Password")}</label>
                      <input
                        className="input ng-untouched ng-pristine ng-invalid"
                        type={!showPassword ? "text" : "password"}
                        name="password"
                        placeholder={t("Password")}
                        {...register("password", {
                          required: t("Enter_Password"),
                          minLength: {
                            value: 6,
                            message: t("PasswordMin"),
                          },
                          maxLength: {
                            value: 20,
                            message: t("PasswordMax"),
                          },
                        })}
                      />
                    </div>
                    {errors.password && errors.password.message && (
                      <div className="alert">{errors.password.message}</div>
                    )}
                  </div>
                </div>
                <div className="login-info-box">
                  <div className="forgetpassword-buttn">
                    <Link to="/forgot-password">{t("ForgotPassword")}</Link>
                  </div>
                </div>
                <button
                  className="button btn-primary app-style"     disabled={loading}
                  style={{
                    border: "none",
                    fontSize: "15px",
                    fontWeight: "600",
                    width: "stretch",
                  }}
                  type="submit"
                >
                  {loading ? (
                    <div
                      _ngcontent-serverapp-c381631582=""
                      class="btn-loading"
                    ></div>
                  ) : (
                    t("Login")
                  )}
                </button>
                <p className="signup">
                  <span>{t("Donothaveanaccount")} </span>
                  <Link to="/register">{t("Singup")}</Link>
                </p>
              </Form>
            </div>
          </div>
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default Login;
